import { Directive, forwardRef, Inject, Input, OnInit, ViewContainerRef } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { ExpandableWidgetDialogComponent } from "./expanded-widget-dialog.component";

@Directive()
export abstract class WidgetWithExpandableDetails implements OnInit {

    @Input() expandableDetails: ExpandableDetails;

    protected expanded: boolean;

    constructor(
        @Inject(forwardRef(() => MatDialog)) protected dialog: MatDialog,
        @Inject(forwardRef(() => ViewContainerRef)) private vcRef: ViewContainerRef
    ) { }

    ngOnInit(): void {
        if (this.expandableDetails) {
            this.expandableDetails.mode = this.expandableDetails.mode || ExpandableDetailMode.POPUP;
            this.expandableDetails.expandIcon = this.expandableDetails.expandIcon || 'expand_content';
        }
    }

    toggleWidgetExpansion(event: Event, defaultTitle: string): void {
        event.stopPropagation();
        if (this.expandableDetails.mode == ExpandableDetailMode.EMBEDDED) {
            this.expanded = !this.expanded;
        } else {
            this.openExpandableWidgetDialog({ title: this.expandableDetails.popupTitle || defaultTitle, templateName: this.expandableDetails.template }, this.vcRef);
        }
    }

    private openExpandableWidgetDialog(data: ExpandableWidgetDialogData, viewContainerRef: ViewContainerRef): void {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.autoFocus = false;
        dialogConfig.minWidth = '25%';
        dialogConfig.minHeight = '300px';
        dialogConfig.data = data;
        dialogConfig.viewContainerRef = viewContainerRef;
        this.dialog.open(ExpandableWidgetDialogComponent, dialogConfig);
    }

}

enum ExpandableDetailMode {
    EMBEDDED = "EMBEDDED",
    POPUP = "POPUP"
}

class ExpandableWidgetDialogData {
    title: string;
    templateName: string;
}

class ExpandableDetails {
    template: string;
    mode: ExpandableDetailMode;
    popupTitle: string;
    expandIcon: string;
}